const PartnerList = () => import('Views/partner/partner-list');

export default[
  { path: '/partner-list', component: PartnerList },
];



// WEBPACK FOOTER //
// ./src/router/partner.js